import React from 'react';
import styled from 'styled-components';

const ComponentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
`
const TitleWrap = styled.h1`
    border-bottom: ${props => props.hasBorder ? '1px solid #b7b7b7' : null };
    padding: 0px 30px 10px 30px;
    margin: 0px;
    font: 18px Open Sans, Helvetica, sans-serif;
    color: #4d4d4d;
`
const SubtitleWrapper = styled.h1`
    padding: 10px;
    margin: 0px;
    font: 18px Open Sans, Helvetica, sans-serif;
    color: ${ props => props.subtitleColor === 'red' ? '#c44c4d' : '#4daeb9'};
    text-align: center;
`

const DialogTitle = ({title, subtitle, subtitleColor, hasBorder, ...styleProps}) => {
    return(
        <ComponentWrapper>
            <TitleWrap hasBorder={hasBorder} >{title}</TitleWrap>
            <SubtitleWrapper subtitleColor={subtitleColor} style={styleProps.subtitlePosition}>{subtitle}</SubtitleWrapper>
        </ComponentWrapper>
    )
}

export default DialogTitle;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/DialogTitle.jsx